// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2CFv7","logo":"Header_logo__14SWD"};